/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MapInteger
 */
export interface MapInteger {
    /**
     * 
     * @type {number}
     * @memberof MapInteger
     */
    _0?: number;
}

/**
 * Check if a given object implements the MapInteger interface.
 */
export function instanceOfMapInteger(value: object): value is MapInteger {
    return true;
}

export function MapIntegerFromJSON(json: any): MapInteger {
    return MapIntegerFromJSONTyped(json, false);
}

export function MapIntegerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MapInteger {
    if (json == null) {
        return json;
    }
    return {
        
        '_0': json['0'] == null ? undefined : json['0'],
    };
}

export function MapIntegerToJSON(json: any): MapInteger {
    return MapIntegerToJSONTyped(json, false);
}

export function MapIntegerToJSONTyped(value?: MapInteger | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '0': value['_0'],
    };
}

